import {
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Tooltip,
} from 'chart.js';
import { memo } from 'react';
import { Bar } from 'react-chartjs-2';

import { WorkOrderData } from '../../../../api/workOrders/types';
import { CHART_TITLES } from '../../constants';
import { groupByUf } from '../../utils/aggregations';
import { ChartCard } from '../ChartCard';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  Tooltip,
  BarController
);

interface TopRegionsProps {
  data: WorkOrderData[];
}

function TopRegionsImpl({ data }: TopRegionsProps): JSX.Element {
  const stats = groupByUf(data, 8);
  const chartData = {
    labels: stats.map((s) => s.uf),
    datasets: [
      {
        label: 'OS',
        data: stats.map((s) => s.count),
        backgroundColor: '#7B3FF2',
        borderRadius: 4,
      },
    ],
  };

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      x: { beginAtZero: true, ticks: { precision: 0 } },
    },
  };

  return (
    <ChartCard
      title={CHART_TITLES.topRegions}
      ariaLabel={`Distribuição por UF: ${stats
        .map((s) => `${s.uf} ${s.count} OS`)
        .join(', ')}.`}
    >
      <Bar data={chartData} options={options} />
    </ChartCard>
  );
}

export const TopRegions = memo(TopRegionsImpl);
